import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-engine-oil-pressure',
  templateUrl: './engine-oil-pressure.component.html',
  styleUrl: './engine-oil-pressure.component.css'
})
export class EngineOilPressureComponent implements OnChanges {
  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;

  public scatterChartData: any = {};

  ngOnChanges(): void {
    this.scatterChartData = {
      xAxis: {
        show: false
      },
      yAxis: {
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      series: [
        {
          symbolSize: 10,
          data: [
            [0, 0],
 
          ],
          itemStyle: {
            color: '#32A7D0' 
          },
          type: 'scatter',
          markLine: {
            data: [
              { yAxis: 8 },
              { yAxis: 4 }
            ],
            lineStyle: {
              type: 'solid',
              color: 'rgba(250, 174, 165, 1)',
              width: 1
            },
            symbol: 'none',
            label: {
              show: false
            }
          }
        }
      ],
      toolbox: {
        show: false 
      },
      grid: {
        top: '10%',
        left: '8%',
        right: '5%',
        bottom: '8%'
      }
    }
  }

}
